import React from 'react';

const statsData = [
    { id: 1, value: "10k+", label: "Learners Upskilled" },
    { id: 2, value: "50+", label: "Industry Partners" },
    { id: 3, value: "900+", label: "Students Placed" },
    { id: 4, value: "4.8/5", label: "Average Rating" }
];

const AboutSection = () => {
    return (
   <>
        <section className="gk-about-section">
            <div className="gk-about-container">

                <div className="gk-about-content">
                    <div className="gk-about-text">
                        <span className="gk-about-tagline">ABOUT US</span>
                        <h2 className="gk-about-title">Bridging Skill Gaps with Industry Training</h2>
                        <p className="gk-about-desc">
                            Skill Ascent is an innovative <strong>online learning platform</strong> dedicated to empowering learners with the skills and knowledge needed to succeed in today’s fast-changing digital world. We specialize in providing high-quality training across a diverse range of fields, including <strong>IT Courses</strong>, <strong>Agriculture</strong>, <strong>Civil & Mechanical Engineering</strong>, <strong>Electronics & Communication</strong>, <strong>Creative & Business</strong>, and <strong>Healthcare Courses</strong> designed to help students and professionals build successful careers.
                        </p>
                        <p className="gk-about-desc">
                            Our mission is to make <strong>online learning</strong> accessible, engaging, and effective for individuals across India and beyond. We focus on practical, industry-relevant training and <strong>job-oriented courses</strong> that help learners achieve real-world results, including <strong>career growth</strong>, <strong>skill enhancement</strong>, and <strong>professional certification</strong> preparation through hands-on learning and expert guidance.
                        </p>
                    </div>

                    <div className="gk-about-stats-grid">
                        {statsData.map((stat) => (
                            <div className="gk-stat-card" key={stat.id}>
                                <h3 className="gk-stat-value">{stat.value}</h3>
                                <p className="gk-stat-label">{stat.label}</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
   </>

    );
};

export default AboutSection;